export default "__VITE_ASSET__BCuPeSqf__"